import { usePrincipal } from '../application/authentication'
import { tDefaults, useWriskTranslation } from '../infrastructure/internationalisation'
import { useApiErrorHandlingAsyncCallback } from './auth'

export const useSetupMandate = (context?: string) => {
  const { t } = useWriskTranslation()

  const { apiClient } = usePrincipal()

  return useApiErrorHandlingAsyncCallback(async () => {
    const url = new URL(window.location.href)

    if (context) {
      url.searchParams.set('context', context)
    }

    const redirectFlow = await apiClient.createRedirectFlow({
      mandateDescription: t(tDefaults('payment-methods.description')),
      successUrl: url.toString(),
    })

    window.location.href = redirectFlow.redirectUrl
  })
}
